<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
        <a @click="toCustomManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-title">客户信息</div>
      <div>
        <div class="form-line">
          <div class="line-text">住户名称：</div>
          <div>{{formData.enterpriseName || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">行业分类：</div>
          <div>{{formData.industry || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">联系人1姓名：</div>
          <div>{{formData.oneContactPersonName || '无'}}</div>
        </div>
      </div>
      <div>
        <div class="form-line">
          <div class="line-text">联系人1手机：</div>
          <div>{{formData.oneContactPersonPhone || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">联系人2姓名：</div>
          <div>{{formData.secContactPersonName || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">联系人2手机：</div>
          <div>{{formData.secContactPersonPhone || '无'}}</div>
        </div>
      </div>
      <div>
        <div class="form-line">
          <div class="line-text">来访途径：</div>
          <div>{{formData.visiteWayText || '无'}}</div>
        </div>
      </div>

      <div class="form-title">推荐人信息</div>
      <div>
        <div class="form-line">
          <div class="line-text">推荐人姓名：</div>
          <div>{{formData.recommendPersonName || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">推荐人手机：</div>
          <div>{{formData.recommendPersonPhone || '无'}}</div>
        </div>
      </div>

      <div class="form-title">客户意向</div>
      <div>
        <div class="form-line">
          <div class="line-text">意向房源：</div>
          <div>{{formData.intendRoom || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">意向面积：</div>
          <div>{{formData.intendArea || '无'}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">客户意向分类：</div>
          <div>{{formData.customIntendTypeText || '无'}}</div>
        </div>
      </div>

      <div class="form-title">预定信息</div>
      <div>
        <div class="form-line">
          <div class="line-text">是否预定：</div>
          <div v-if="formData.orderOrNot === '0'">已预定</div>
          <div v-if="formData.orderOrNot === '1'">未预定</div>
        </div>
        <div class="form-line" v-if="formData.orderOrNot === '0'">
          <div class="line-text">预定金：</div>
          <div>{{formData.roomDeposit || '无'}}</div>
        </div>
      </div>

      <div class="form-title">其他</div>
      <div>
        <div class="form-line">
          <div class="line-text">跟进人：</div>
          <div>{{formData.fellowPeopleName || '无'}}</div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/agent'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      TextTitle,
      Breadcrumb},
    name: 'custom-current',
    data () {
      return {
        breadcrumb: [{
          value: '智慧合约',
          name: 'custom-management'
        }, {
          value: '客户管理'
        }],
        mainTitle: '查看客户',
        subheading: '',
        formData: {},
        currentCode: ''
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getCustomByCode()
    },
    methods: {
      toCustomManagement () {
        this.$router.push({
          name: 'custom-management'
        })
      },
      toModifyPage () {
        this.$router.push({
          path: `/custom_modify/${this.currentCode}`
        })
      },
      getCustomByCode () {
        this.$axios.get(`${api.getCustomByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.customIntendType === '0') {
                data.customIntendTypeText = '未分类'
              } else if (data.customIntendType === '1') {
                data.customIntendTypeText = '潜在客户'
              } else if (data.customIntendType === '2') {
                data.customIntendTypeText = '意向客户'
              } else if (data.customIntendType === '3') {
                data.customIntendTypeText = '成交客户'
              } else if (data.customIntendType === '4') {
                data.customIntendTypeText = '流失客户'
              }
              if (data.visiteWay === '0') {
                data.visiteWayText = '电话'
              } else if (data.visiteWay === '1') {
                data.visiteWayText = '上门'
              } else if (data.visiteWay === '2') {
                data.visiteWayText = '小程序推荐'
              } else if (data.visiteWay === '3') {
                data.visiteWayText = '住户推荐'
              }
              this.formData = data
            }
          })
          .catch(errorHandler('查询客户失败'))
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  form > div {
    display: flex;
    justify-content: flex-start;
  }
  form > div >div {
    min-width: 320px;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/CustomManagement/CustomCurrent.vue